import { Layer, Placeholder, Map, MapType } from '@/@types/graphql';
import { MAP_URL } from '@/constants';
import { Vue, Component } from 'vue-property-decorator';

export interface FiberMapQueries {
  [key: string]: string;
}

@Component({ name: 'fiber-map-mixin' })
export default class FiberMap extends Vue {
  initCallbackMethods () {
    if (!window) return;
    (window as any).goTo = (target: any) => {
      console.log(target, JSON.stringify(target))
      switch (target.type) {
        case 'pointOfInterest':
          return this.$router.push({
            name: 'single-poi',
            params: { uuid: target.id },
            query: target.contextCollection
              ? { collection: target.contextCollection }
              : {}
          });
        case 'collection':
          this.$router.push({
            name: 'single-collection',
            params: { uuid: target.id }
          });
        case 'url': 
          const urlRegex = /^https?:\/\/(?:[\w-]+\.)+(?!\/)(?:[\w]{2,}\/?)+(?:\?[\w-]+=[\w-]+(?:&[\w-]+=[\w-]+)*)?(?:#[\w-]+)?$/
          if (!target.url || target.url.length < 3) return console.warn('Invalid URL ', target.url) // Invalid URL
          if (!urlRegex.test(target.url)) return this.$router.push(target.url) // URL local, on utilise le router
          return window.open(target.url, target.openSelfTab ? '_self' : '_blank')
        default:
          console.warn('Map go To target undefined', target, JSON.stringify(target));
          break;
      }
    };
  }

  redirectToMap (queries: FiberMapQueries = {}) {
    if (!MAP_URL) return;
    this.$router.push({ name: 'fiber-map', query: queries });
  }

  showPlaceholder ({ id, layer }: Placeholder) {
    return this.redirectToMap({
      placeholderId: id,
      mapType: layer?.map?.type || MapType.Threejs,
    });
  }

  showLayer (layer: Layer | null = null) {
    if (!layer) return this.redirectToMap();
    return this.redirectToMap({ layerId: layer.id });
  }

  showMap (map: Map | null = null) {
    if (!map) return this.redirectToMap();
    return this.redirectToMap({ mapId: map.id });
  }
}
